export const scenario6 = {
  id: 225,
  categories: [
    {
      id: 323,
      name: 'Half Day Spa',
    },
  ],
  name: 'Mud Chamber Day',
  description:
    '### Included\n\n- Mud Chamber\n- Yoga For Beginners\n- Mocktail/non-alcoholic Drink',
  termsAndConditions: null,
  image: {
    externalKey: 'a08e05399cc44676fb89b4705d1c906e',
    url: 'https://products-stage-onejourney-private.s3.amazonaws.com/a08e05399cc44676fb89b4705d1c906e.jpg',
  },
  numberOfGuests: 1,
  durationText: 'half_day',
  gender: null,
  displayOrder: 103,
  price: {
    amount: 5000,
    currencyCode: 'gbp',
  },
  supportsTimeslots: true,
  configurationGroupsRequireTimeslots: true,
  configurationGroupsSupportTimeslots: true,
  crossSellObjects: [
    {
      object: {
        id: 133,
        categories: [
          {
            id: 323,
            name: 'Half Day Spa',
          },
        ],
        name: 'Yummy Mummy',
        description: 'Perfect for mums-to-be seeking relaxing TLC.\n\nIncludes 60 minute massage',
        image: {
          externalKey: '0132b72c9e12d6b42ec581ada353acd0',
          url: 'https://products-stage-onejourney-private.s3.amazonaws.com/0132b72c9e12d6b42ec581ada353acd0.jpg',
        },
        price: {
          amount: 5000,
          currencyCode: 'gbp',
        },
      },
      type: 'spa-package',
    },
    {
      object: {
        id: 224,
        categories: [
          {
            id: 322,
            name: 'Full Day Spa',
          },
        ],
        name: 'Mum To Be Spa Day',
        description:
          '### Included\n\n- Deluxe Body Treatment\n- Spa Access\n- Mocktail/non-alcoholic Drink\n- Face Mask Or Scrub\n\n### Options - 1 of the following\n\n- Luxury Manicure\n- Luxury Pedicure',
        image: {
          externalKey: 'e72bcb49608ad7b36600044760a04ce6',
          url: 'https://products-stage-onejourney-private.s3.amazonaws.com/e72bcb49608ad7b36600044760a04ce6.jpg',
        },
        price: {
          amount: 12500,
          currencyCode: 'gbp',
        },
      },
      type: 'spa-package',
    },
    {
      object: {
        id: 130,
        categories: [
          {
            id: 322,
            name: 'Full Day Spa',
          },
        ],
        name: 'Spa Retreat',
        description:
          'Treat yourself to a rejuvenating spa day experience at our tranquil day spa retreat.\n\n**Included in you spa day:**\n- Bath Robe\n- Slippers\n- Glass Of Prosecco\n\n**Choose from one of the following**\n- Aromatherapy\n- Essential Facial\n- Lime Scrub\n\n**...And two of the following**\n- Luxury Pedicure\n- Luxury Manicure\n- Deep Cleansing Facial\n- Deluxe Body Treatment',
        image: {
          externalKey: '034b8fc52166378b7ab642a8ff9e4a78',
          url: 'https://products-stage-onejourney-private.s3.amazonaws.com/034b8fc52166378b7ab642a8ff9e4a78.jpg',
        },
        price: {
          amount: 8000,
          currencyCode: 'gbp',
        },
      },
      type: 'spa-package',
    },
  ],
  upSell: null,
  timeSlots: [
    {
      startTime: '09:00:00',
      endTime: '12:00:00',
      price: {
        amount: 5000,
        currencyCode: 'gbp',
      },
      quantity: null,
      durationMinutes: 180,
    },
    {
      startTime: '12:00:00',
      endTime: '15:00:00',
      price: {
        amount: 5000,
        currencyCode: 'gbp',
      },
      quantity: null,
      durationMinutes: 180,
    },
  ],
  configurationGroups: [
    {
      id: 372,
      name: null,
      minimumSelections: null,
      maximumSelections: null,
      optionsPerGuest: true,
      isExtras: false,
      supportsSelections: false,
      supportsTimeslots: true,
      isRequired: true,
      options: [
        {
          id: 2728,
          name: 'Mud Chamber',
          description: null,
          image: null,
          price: null,
          extra: null,
          featured: null,
          supportsTimeslots: false,
          type: null,
        },
        {
          id: 2729,
          name: 'Yoga For Beginners',
          description: null,
          image: {
            externalKey: '0231d68e590a5571d7debc40858e2a13',
            url: 'https://products-stage-onejourney-private.s3.amazonaws.com/0231d68e590a5571d7debc40858e2a13.jpg',
          },
          price: null,
          extra: null,
          featured: null,
          supportsTimeslots: true,
          type: 'spa-classes',
          timeslots: [
            {
              startTime: '14:00:00',
              endTime: '15:00:00',
              price: {
                amount: 800,
                currencyCode: 'gbp',
              },
              quantity: 10,
              durationMinutes: 60,
            },
          ],
        },
        {
          id: 2730,
          name: 'Mocktail/non-alcoholic Drink',
          description:
            'Sed dignissim, purus sed aliquet ultricies, nunc tortor blandit libero, a facilisis erat orci non ex. Praesent at elit molestie, malesuada magna id, viverra urna.',
          image: {
            externalKey: 'bc919ee2f6deaf49d529aeacae6bcca2',
            url: 'https://products-stage-onejourney-private.s3.amazonaws.com/bc919ee2f6deaf49d529aeacae6bcca2.jpg',
          },
          price: null,
          extra: {
            id: 82,
          },
          featured: true,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
      ],
      isBookable: true,
    },
    {
      id: null,
      name: 'Extras',
      minimumSelections: null,
      maximumSelections: null,
      optionsPerGuest: true,
      isExtras: true,
      supportsSelections: false,
      supportsTimeslots: false,
      isRequired: false,
      options: [
        {
          id: null,
          name: 'Bath Robe',
          description: '',
          image: null,
          price: {
            amount: 1998,
            currencyCode: 'gbp',
          },
          extra: {
            id: 76,
          },
          featured: false,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
        {
          id: null,
          name: 'Celebration Balloon',
          description:
            'Aliquam arcu sem, efficitur a mi volutpat, pulvinar mattis sapien. Praesent a turpis sed enim sollicitudin tincidunt in et ante.',
          image: {
            externalKey: '9f38cedbd6e7ceb0a45d41ccce523de4',
            url: 'https://products-stage-onejourney-private.s3.amazonaws.com/9f38cedbd6e7ceb0a45d41ccce523de4.jpg',
          },
          price: {
            amount: 599,
            currencyCode: 'gbp',
          },
          extra: {
            id: 77,
          },
          featured: false,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
        {
          id: null,
          name: 'Exclusive Hot Tub Usage',
          description:
            'Enjoy a 30 minute private hot tub experience for two adults in one of our bespoke Cedar Tubs in our spa terrace.\n\nPlease Note: Price is per tub and valid for 2 people. You only need to select this experience for one guest if booking your spa day for 2 people.',
          image: {
            externalKey: '33df840bc541727f57482c2f1046fc3d',
            url: 'https://products-stage-onejourney-private.s3.amazonaws.com/33df840bc541727f57482c2f1046fc3d.jpg',
          },
          price: {
            amount: 1500,
            currencyCode: 'gbp',
          },
          extra: {
            id: 78,
          },
          featured: true,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
        {
          id: null,
          name: 'Face Mask Or Scrub',
          description:
            'Proin vel velit ut tortor vulputate auctor. Sed eleifend felis metus, in semper nunc efficitur non. Curabitur luctus vitae felis maximus tempus.',
          image: {
            externalKey: '0f938d2329aac3824ffade6fc352e6af',
            url: 'https://products-stage-onejourney-private.s3.amazonaws.com/0f938d2329aac3824ffade6fc352e6af.jpg',
          },
          price: {
            amount: 999,
            currencyCode: 'gbp',
          },
          extra: {
            id: 79,
          },
          featured: true,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
        {
          id: null,
          name: 'Glass Of Prosecco',
          description: 'A Glass of Fizz on arrival to start your spa experience.',
          image: {
            externalKey: 'afa896e8cebd36e0cfc8dbcf15bc784b',
            url: 'https://products-stage-onejourney-private.s3.amazonaws.com/afa896e8cebd36e0cfc8dbcf15bc784b.jpg',
          },
          price: {
            amount: 999,
            currencyCode: 'gbp',
          },
          extra: {
            id: 80,
          },
          featured: true,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
        {
          id: null,
          name: 'Mocktail/non-alcoholic Drink',
          description:
            'Sed dignissim, purus sed aliquet ultricies, nunc tortor blandit libero, a facilisis erat orci non ex. Praesent at elit molestie, malesuada magna id, viverra urna.',
          image: {
            externalKey: 'bc919ee2f6deaf49d529aeacae6bcca2',
            url: 'https://products-stage-onejourney-private.s3.amazonaws.com/bc919ee2f6deaf49d529aeacae6bcca2.jpg',
          },
          price: {
            amount: 599,
            currencyCode: 'gbp',
          },
          extra: {
            id: 82,
          },
          featured: true,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
        {
          id: null,
          name: 'Mud Chamber For Two',
          description: '',
          image: null,
          price: {
            amount: 5000,
            currencyCode: 'gbp',
          },
          extra: {
            id: 83,
          },
          featured: false,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
        {
          id: null,
          name: 'Newspaper',
          description: '',
          image: null,
          price: {
            amount: 0,
            currencyCode: 'gbp',
          },
          extra: {
            id: 84,
          },
          featured: false,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
        {
          id: null,
          name: 'Skin Care Workshop',
          description: '',
          image: null,
          price: {
            amount: 0,
            currencyCode: 'gbp',
          },
          extra: {
            id: 85,
          },
          featured: false,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
        {
          id: null,
          name: 'Slippers',
          description: '',
          image: null,
          price: {
            amount: 575,
            currencyCode: 'gbp',
          },
          extra: {
            id: 86,
          },
          featured: false,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
        {
          id: null,
          name: 'Towel',
          description: '',
          image: null,
          price: {
            amount: 999,
            currencyCode: 'gbp',
          },
          extra: {
            id: 89,
          },
          featured: false,
          supportsTimeslots: false,
          type: 'spa-extras',
        },
      ],
    },
  ],
};
